module.exports = __webpack_public_path__ + "images/locator/icon-map-view-17413d1b.svg";